import React, { useState } from 'react';
import axios from 'axios';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    course: '',
    batch: '',
    source: '',
    description: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('http://localhost:4000/api/student-contact', formData);
      setSubmitted(true);
      setTimeout(() => {
        window.location.href = "https://medi-cpcawshjx-santhiyasanthiyas-projects.vercel.app";
      }, 2500);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="alpha_stud_pg_wrapper">
      <div className="alpha_stud_pg_container">
        <div className="alpha_stud_pg_card">
          {submitted ? (
            <div className="alpha_stud_pg_success_view">
              <div className="alpha_stud_pg_success_icon_wrapper">
                <div className="alpha_stud_pg_check_icon">✓</div>
              </div>
              <h2 className="alpha_stud_pg_success_title">Inquiry Received!</h2>
              <p className="alpha_stud_pg_success_p">Your medical coding journey starts here. Our team will reach out to you within 24 hours.</p>
              <div className="alpha_stud_pg_loader_bar"></div>
              <p className="alpha_stud_pg_redirect_msg">Returning to home page...</p>
            </div>
          ) : (
            <>
            
              
              <form onSubmit={handleFormSubmit} className="alpha_stud_pg_form">
                <div className="alpha_stud_pg_field_full">
                  <label className="alpha_stud_pg_label">Full Name</label>
                  <input 
                    className="alpha_stud_pg_input"
                    type="text" name="name" 
                    placeholder="e.g. John Doe"
                    value={formData.name} onChange={handleChange} required 
                  />
                </div>

                <div className="alpha_stud_pg_row">
                  <div className="alpha_stud_pg_field">
                    <label className="alpha_stud_pg_label">Mobile Number</label>
                    <input 
                      className="alpha_stud_pg_input"
                      type="tel" name="phone" 
                      placeholder="Enter 10 digit number"
                      value={formData.phone} onChange={handleChange} required 
                    />
                  </div>

                  <div className="alpha_stud_pg_field">
                    <label className="alpha_stud_pg_label">Email Address</label>
                    <input 
                      className="alpha_stud_pg_input"
                      type="email" name="email" 
                      placeholder="name@example.com"
                      value={formData.email} onChange={handleChange} required 
                    />
                  </div>
                </div>

                <div className="alpha_stud_pg_field_full">
                  <label className="alpha_stud_pg_label">Interested Course</label>
                  <select className="alpha_stud_pg_select" name="course" value={formData.course} onChange={handleChange} required>
                    <option value="">Choose a certification training</option>
                    <option value="CPC">CPC (Certified Professional Coder)</option>
                    <option value="CCS">CCS (Certified Coding Specialist)</option>
                    <option value="CRC">CRC (Certified Risk Adjustment Coder)</option>
                    <option value="Basic Medical Coding Training">Basic Medical Coding Training</option>
                    <option value="Advanced Medical Coding Training">Advanced Medical Coding Training</option>
                    <option value="Specialty Training">Specialty Training</option>
                  </select>
                </div>

                <div className="alpha_stud_pg_row">
                  <div className="alpha_stud_pg_field">
                    <label className="alpha_stud_pg_label">Preferred Batch</label>
                    <select className="alpha_stud_pg_select" name="batch" value={formData.batch} onChange={handleChange} required>
                      <option value="">- Select -</option>
                      <option value="Morning">Morning</option>
                      <option value="Evening">Evening</option>
                      <option value="Weekend">Weekend</option>
                    </select>
                  </div>

                  <div className="alpha_stud_pg_field">
                    <label className="alpha_stud_pg_label">How did you find us?</label>
                    <select className="alpha_stud_pg_select" name="source" value={formData.source} onChange={handleChange} required>
                      <option value="">- Select -</option>
                      <option value="Referral">Referral</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Walk-in">Walk-in</option>
                      <option value="Website">Website</option>
                    </select>
                  </div>
                </div>

                <div className="alpha_stud_pg_field_full">
                  <label className="alpha_stud_pg_label">Additional Message</label>
                  <textarea 
                    className="alpha_stud_pg_textarea"
                    name="description" 
                    placeholder="Tell us about your educational background or specific requirements..."
                    rows="2"
                    value={formData.description} onChange={handleChange}
                  ></textarea>
                </div>

                <button type="submit" className="alpha_stud_pg_btn" disabled={loading}>
                  {loading ? (
                    <span className="alpha_stud_pg_loading_flex">
                       Processing...
                    </span>
                  ) : "Submit Inquiry"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;